
class ProductStickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.mainButtons = document.getElementById('productFormButtons');
    this.debouncedOnLoad = debounce((event) => {
      // when bottom is reached, hide the bar. Use math because it can return a half pixel... 
      if (event.type === 'scroll' && (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight) {
        this.hideBar();
        return
      }
      this.showBar(event);
    }, 50);

    window.addEventListener('scroll', this.debouncedOnLoad.bind(this));

  }

  showBar(event) {
    // register IntersectionObserver
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { 
        const elementBounds = entry.boundingClientRect;
        const isBottomVisible = (elementBounds.top <= 10 );
        // display the bar when the ATC button is out of screen
        if (isBottomVisible) {
          this.classList.add('product-sticky--active');
        }
        else {
          this.hideBar();
        }
      });
    });
    // declares what to observe, and observes its properties.
    observer.observe(this.mainButtons);
  }

  hideBar() {
    this.classList.remove('product-sticky--active');
  }
}

if(!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', ProductStickyAddToCart);
}